module.exports = __webpack_public_path__ + "static/media/211EC146.12ccbf8a.jpg";